// Styles for CreateAccountConsentsForm go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledCreateAccountConsentsForm = styled.div`
  .create-account-consents-form-container-account {
    @media ${baseVariables.mediaQuery.md} {
      margin-bottom: ${toRem(64)} !important;
    }

    @media ${baseVariables.mediaQuery.xl} {
      margin-bottom: ${toRem(56)} !important;
    }

    .create-account-consents-form-wrapper {
      background-color: ${baseVariables.color.base20};
      min-width: ${toRem(332)};
      padding: 0 !important;

      &__border {
        border-radius: 0 0 ${toRem(14)} ${toRem(14)};
        box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 ${baseVariables.shadows.boxShadowTile};
      }

      @media ${baseVariables.mediaQuery.md} {
        max-width: ${toRem(704)};
      }

      @media ${baseVariables.mediaQuery.lg} {
        max-width: ${toRem(1140)};
      }

      @media ${baseVariables.mediaQuery.xl} {
        top: ${toRem(-240)};
      }
    }
  }

  .create-account-consents-form-container.spacing {
    .create-account-consents-form-wrapper {
      padding-top: ${toRem(40)};

      @media ${baseVariables.mediaQuery.md} {
        padding-top: ${toRem(80)};
      }
    }
  }
  .link-underline {
    text-decoration: underline;
  }
  .create-account-submit-mobile {
    width: 100%;
  }
  @media ${baseVariables.mediaQuery.md} {
    .create-account-submit-mobile {
      width: auto;
    }
  }

  .submit_btn-wrapper {
    padding: ${toRem(16)} ${toRem(16)} ${toRem(32)} ${toRem(16)}!important;
    @media ${baseVariables.mediaQuery.md} {
      padding: ${toRem(32)} ${toRem(52)} !important;
    }
    @media ${baseVariables.mediaQuery.lg} {
      padding: ${toRem(16)} ${toRem(98)} ${toRem(32)} ${toRem(98)} !important;
    }
  }
  .create-account-consent {
    padding: 0 ${toRem(16)} !important;
    @media ${baseVariables.mediaQuery.md} {
      padding: 0 ${toRem(52)} !important;
    }
    @media ${baseVariables.mediaQuery.lg} {
      padding: 0 ${toRem(84)} !important;
    }
    .consent-checkbox {
      label {
        &:before {
          outline: none;
        }
      }
    }
  }
  .submit_btn {
    width: 100%;
    max-width: ${toRem(360)};
    @media ${baseVariables.mediaQuery.md} {
      width: unset;
    }
  }
  .default-consent {
    padding: ${toRem(24)} ${toRem(16)} !important;

    @media ${baseVariables.mediaQuery.md} {
      padding: ${toRem(32)} ${toRem(52)} !important;
    }
    @media ${baseVariables.mediaQuery.lg} {
      padding: ${toRem(32)} ${toRem(98)} !important;
    }

    &__description {
      padding: 0 ${toRem(16)} ${toRem(24)} ${toRem(16)} !important;
      @media ${baseVariables.mediaQuery.md} {
        padding: 0 ${toRem(52)} ${toRem(16)} ${toRem(52)} !important;
      }
      @media ${baseVariables.mediaQuery.lg} {
        padding: 0 ${toRem(98)} ${toRem(16)} ${toRem(98)} !important;
      }

      p {
        margin-bottom: 0;
      }
    }
  }
  .copyright-wrapper {
    @media ${baseVariables.mediaQuery.md} {
      padding: 0 ${toRem(52)} !important;
    }
    @media ${baseVariables.mediaQuery.lg} {
      padding: 0 ${toRem(98)} 0 ${toRem(98)} !important;
    }
    &.has-special-consent {
      padding: 0 ${toRem(84)} 0 ${toRem(84)} !important;
    }
  }
  .account-legal-consents {
    &:not(.eaa-enabled) {
      background-color: ${baseVariables.color.base20};
      box-shadow: ${toRem(10)} ${toRem(-10)} ${toRem(10)} ${toRem(-10)} ${baseVariables.shadows.boxShadowTile},
        ${toRem(-10)} ${toRem(-10)} ${toRem(10)} ${toRem(-10)} ${baseVariables.shadows.boxShadowTile};
    }
    min-width: ${toRem(332)};
    @media ${baseVariables.mediaQuery.md} {
      max-width: ${toRem(704)};
    }
    @media ${baseVariables.mediaQuery.lg} {
      max-width: ${toRem(1140)};
    }
    .m-consent-list {
      padding-right: ${toRem(16)} !important;
      padding-left: ${toRem(16)} !important;

      @media ${baseVariables.mediaQuery.md} {
        padding-right: ${toRem(52)} !important;
        padding-left: ${toRem(52)} !important;
      }
      @media ${baseVariables.mediaQuery.lg} {
        padding-right: ${toRem(84)} !important;
        padding-left: ${toRem(84)} !important;
      }
    }
    div.m-legal-ConsentListItem:last-of-type,
    div[data-testid='legal-ConsentCheckListItem']:last-of-type,
    div[data-testid='legal-ConsentListItem']:last-of-type {
      margin-bottom: 0 !important;
    }
    div[data-testid='legal-ConsentListItem']:first-of-type {
      margin-top: 0 !important;
    }
  }
  .legal-consent-error-msg {
    min-width: ${toRem(332)};
    padding-right: ${toRem(24)} !important;
    padding-left: ${toRem(24)} !important;

    @media ${baseVariables.mediaQuery.md} {
      max-width: ${toRem(704)};
      padding-right: ${toRem(56)} !important;
      padding-left: ${toRem(56)} !important;
    }
    @media ${baseVariables.mediaQuery.lg} {
      max-width: ${toRem(1140)};
      padding-right: ${toRem(88)} !important;
      padding-left: ${toRem(88)} !important;
    }
    .m-message-content {
      p {
        margin-bottom: 0 !important;
      }
    }
  }
  .footer-background {
    background-color: ${baseVariables.color.base20};
    border-radius: 0 0 ${toRem(14)} ${toRem(14)};
    box-shadow: 0 ${toRem(4)} ${toRem(4)} 0 ${baseVariables.shadows.boxShadowTile};
  }
`;
